module.exports = __webpack_public_path__ + "img/2024517-icon2-active.339922a.svg";